import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import LoginView from './views/Login/LoginView';
import PrivateRoutes from './routing/PrivateRoutes';
import NotFoundView from './views/StatusPages/NotFoundView';
import ModsView from './views/Mods/ModsView';
import ScenarioPanel from './views/Scenarios/ScenariosView';
import ServersView from './views/Servers/ServersView';
import AddServerView from './views/AddServer/AddServerView';

const App = () =>
{
	return (
		<div id='app' >
			<BrowserRouter>
				<Routes>
					<Route path='/login' element={<LoginView />} />
					<Route path='/' element={<LoginView />} />
					<Route element={<PrivateRoutes />}>
						<Route path='/mods' element={<ModsView />} />
						<Route path='/scenarios' element={<ScenarioPanel />} />
						<Route path='/servers' element={<ServersView />} />
						<Route path='/servers/add' element={<AddServerView />} />
					</Route>
					<Route path='*' element={<NotFoundView />} />
				</Routes>
			</BrowserRouter>
		</div>
	);
};

export default App;
